"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserBase = void 0;
// Vendors
const react_1 = require("react");
// Hooks
const useAuthoriserNotifications_hook_1 = require("../../../authoriser/hooks/useAuthoriserNotifications/useAuthoriserNotifications.hook");
const useChallengeBase_hook_1 = require("../../../authoriser/hooks/useChallenge/useChallengeBase.hook");
const useAuthoriserBase = ({ authoriser, onStart, onFail, onReadyToFinish, onFinish, onVerify, onVerifyError, }) => {
    const { state, ...challengesData } = (0, useChallengeBase_hook_1.useChallengeBase)({
        authoriser,
        onVerify,
        onVerifyError,
    });
    const notifications = (0, useAuthoriserNotifications_hook_1.useAuthoriserNotifications)();
    (0, react_1.useEffect)(() => {
        state.isStarted && onStart?.();
    }, [state.isStarted]);
    (0, react_1.useEffect)(() => {
        state.isFinished && onFinish?.();
    }, [state.isFinished]);
    (0, react_1.useEffect)(() => {
        onReadyToFinish?.(state.isReadyToFinish);
    }, [state.isReadyToFinish]);
    (0, react_1.useEffect)(() => {
        state.isFailed && onFail?.();
    }, [state.isFailed]);
    return {
        state,
        isStarted: state.isStarted,
        isFinished: state.isReadyToFinish,
        isFailed: state.isFailed,
        isAuthoriserFlowBlocked: state.isBlocked,
        handleReset: () => authoriser.reset(),
        ...challengesData,
        ...notifications,
    };
};
exports.useAuthoriserBase = useAuthoriserBase;
exports.default = exports.useAuthoriserBase;
//# sourceMappingURL=useAuthoriserBase.hook.js.map